
<nz-button-group>
    <button [nz-tooltip]="'Common.MoreBtns' | translate" [nzTooltipTitle]="'Common.MoreBtns' | translate" nz-button (click)="showMoreButton()">
        <span>{{'Common.MoreBtns' | translate}}</span>  
    </button>
    <button id="moreButton" [nz-tooltip]="'Common.MoreBtns' | translate" [nzTooltipTitle]="'Common.MoreBtns' | translate" 
    nz-button nz-dropdown [nzOverlayClassName]="'dropdown-more-button'" [nzDropdownMenu]="menu1" [nzTrigger]="'click'"nzPlacement="bottomRight">
    <span nz-icon nzType="ellipsis"></span>
    </button>
</nz-button-group>
<nz-dropdown-menu #menu1>
    <ng-content></ng-content>
</nz-dropdown-menu>


